/** Keeps the conversation stable while the composer, keyboard, or panel changes size. */
export class TranscriptViewport {
  private element?: HTMLElement;
  private observer?: ResizeObserver;
  private top = 0;
  private pinned = true;
  private messageCount = 0;
  private viewportHeight = 0;

  detach() {
    if (this.element) {
      this.top = this.element.scrollTop;
      if (this.element.clientHeight === this.viewportHeight)
        this.pinned = this.isAtEnd(this.element);
    }
    this.observer?.disconnect();
    this.element = undefined;
  }

  attach(element: HTMLElement, messageCount: number) {
    if (messageCount > this.messageCount) this.pinned = true;
    this.messageCount = messageCount;
    this.element = element;
    this.viewportHeight = element.clientHeight;
    // Layout measurements must happen after the panel is attached to the document.
    element.scrollTop = this.pinned ? element.scrollHeight : this.top;
    element.addEventListener(
      "scroll",
      () => {
        if (this.element !== element) return;
        // Keyboard/viewport resizing can emit scroll before ResizeObserver runs.
        // Layout movement must not be mistaken for reading older messages.
        if (element.clientHeight !== this.viewportHeight) {
          this.viewportHeight = element.clientHeight;
          this.keepLatestVisible();
          return;
        }
        this.top = element.scrollTop;
        this.pinned = this.isAtEnd(element);
      },
      { passive: true }
    );
    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(() => {
        this.viewportHeight = element.clientHeight;
        this.keepLatestVisible();
      });
      this.observer.observe(element);
    }
  }

  keepLatestVisible() {
    if (this.pinned && this.element?.isConnected) {
      this.element.scrollTop = this.element.scrollHeight;
    }
  }

  private isAtEnd(element: HTMLElement) {
    return element.scrollHeight - element.clientHeight - element.scrollTop <= 40;
  }
}
